var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.visibilityChanged,
  }),expression:"{\n    callback: visibilityChanged,\n  }"}],ref:"editor",attrs:{"value":_vm.value,"options":_vm.options},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }